<ng-container
  *ngComponentOutlet="getAuthMethodContent();
  injector: objectInjector;">
</ng-container>
